import React, { useState } from "react";
import { Button, Grid, Paper } from "@mui/material";
import { CampaignOutlined, WarningAmberOutlined } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { toggleModal } from "app/store/patient/slice/patientSlice";
import PatientBulktUpdateModal from "./PatientBulktUpdateModal";
import { isValidArray } from "utils/array";

const useStyles = makeStyles({
  paper: { padding: "10px 12px", borderRadius: "4px" },
  selectedButton: {
    borderRadius: "50px",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    padding: "0 15px !important",
    color: "#757575",
    borderColor: "#E0E0E0",
  },
  defaultButton: {
    color: "#757575",
  },
});

const PatientBulkActionModal = ({ leadModel, selectedPatients = [] }) => {
  const classes = useStyles();
  const { totalSelectedRows, showDeviceAlertModal, showAdvisoryModal } =
    useSelector((state) => state.patient);
  const dispatch = useDispatch();
  const [modalType, setModalType] = useState();

  // Validate if leadModel matches all selected rows' leads
  const isAdvisoryButtonDisabled = () => {
    if (!leadModel || selectedPatients.length === 0) return true;

    const leadModelLower = leadModel?.toLowerCase();
    return !selectedPatients.every((patient) => {
      const patientData = patient;
      const leads = patientData?.deviceInformation?.leads || [];

      return (
        isValidArray(leads) &&
        leads.some((lead) => lead?.toLowerCase() === leadModelLower)
      );
    });
  };

  return (
    <Grid container justifyContent="center" className="trans-table__process">
      {totalSelectedRows > 0 && (
        <Grid item>
          <Paper
            className={classes.paper}
            component={Grid}
            display="flex"
            justifyContent="space-between"
          >
            <Button
              color="primary"
              variant="outlined"
              className={classes.selectedButton}
            >
              {totalSelectedRows} Selected
            </Button>

            <div>
              <Button
                className={classes.defaultButton}
                variant="text"
                onClick={() => {
                  const type = "showDeviceAlertModal";

                  dispatch(
                    toggleModal({
                      type,
                      value: !showDeviceAlertModal,
                    })
                  );
                  setModalType(type);
                }}
                startIcon={<WarningAmberOutlined />}
              >
                Device Alert
              </Button>
              <Button
                variant="text"
                color="inherit"
                disabled={isAdvisoryButtonDisabled()}
                onClick={() => {
                  const type = "showAdvisoryModal";

                  dispatch(
                    toggleModal({
                      type: "showAdvisoryModal",
                      value: !showAdvisoryModal,
                    })
                  );
                  setModalType(type);
                }}
                className={classes.defaultButton}
                startIcon={<CampaignOutlined />}
              >
                Advisory
              </Button>
            </div>
          </Paper>
        </Grid>
      )}

      {(showDeviceAlertModal || showAdvisoryModal) && (
        <PatientBulktUpdateModal modalType={modalType} leadModel={leadModel} />
      )}
    </Grid>
  );
};

export default PatientBulkActionModal;
